"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useArtifactMappingExamptionQuery = require("./useArtifactMappingExamptionQuery");
Object.keys(_useArtifactMappingExamptionQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useArtifactMappingExamptionQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useArtifactMappingExamptionQuery[key];
    }
  });
});
var _useArtifactOwnershipQuery = require("./useArtifactOwnershipQuery");
Object.keys(_useArtifactOwnershipQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useArtifactOwnershipQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useArtifactOwnershipQuery[key];
    }
  });
});
var _useArtifactProductsQuery = require("./useArtifactProductsQuery");
Object.keys(_useArtifactProductsQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useArtifactProductsQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useArtifactProductsQuery[key];
    }
  });
});
var _useTagsQuery = require("./useTagsQuery");
Object.keys(_useTagsQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTagsQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useTagsQuery[key];
    }
  });
});
var _useEditClassificationPermissionQuery = require("./useEditClassificationPermissionQuery");
Object.keys(_useEditClassificationPermissionQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useEditClassificationPermissionQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useEditClassificationPermissionQuery[key];
    }
  });
});
var _useEditAssignmentPermissionQuery = require("./useEditAssignmentPermissionQuery");
Object.keys(_useEditAssignmentPermissionQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useEditAssignmentPermissionQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useEditAssignmentPermissionQuery[key];
    }
  });
});
var _useProductsQuery = require("./useProductsQuery");
Object.keys(_useProductsQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProductsQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useProductsQuery[key];
    }
  });
});